export default function zeroPrefill(
  number: number | string,
  width = 2,
): string {
  if (String(number).length >= width) return String(number);
  return (new Array(width).join('0') + String(number)).substring(-width);
}
